import { Heart } from "lucide-react";

/** Client Portal v2 (2026-09, Phase 1, §5) — PM-authored project updates (Notion
 * "Published"-gated, see modules/client_updates.py) with a simple on/off acknowledgement
 * reaction per update. Now sits inside the Communication section on the light content
 * surface, below Meetings — restyled from dark `cp-card` rows to light `cp-row-divider` rows. */
export function UpdatesFeed({ updates, onReact }) {
  if (!updates || updates.length === 0) {
    return (
      <p className="text-[13.5px] text-[color:var(--cp-grey-3)]" data-testid="client-portal-updates-empty">Your PM's updates will appear here as the project moves forward.</p>
    );
  }
  return (
    <div data-testid="client-portal-updates-list">
      {updates.map((u) => (
        <div key={u.id} className="cp-row-divider py-4" data-testid={`client-portal-update-${u.id}`}>
          <span className="text-[10.5px] font-semibold uppercase tracking-wide text-[color:var(--cp-grey-4)]">{u.date}</span>
          <h4 className="text-[14.5px] font-semibold text-[color:var(--cp-ink-text)] mt-1 mb-1.5">{u.name}</h4>
          <p className="text-[13px] text-[color:var(--cp-grey-1)] leading-relaxed whitespace-pre-wrap">{u.body}</p>
          <button
            onClick={() => onReact(u.id)}
            data-testid={`client-portal-update-react-btn-${u.id}`}
            className={`mt-3 inline-flex items-center gap-1.5 text-xs transition-colors ${u.reacted_by_me ? "text-[color:var(--cp-gold-dim)]" : "text-[color:var(--cp-grey-4)] hover:text-[color:var(--cp-ink-text)]"}`}
          >
            <Heart className={`h-3.5 w-3.5 ${u.reacted_by_me ? "fill-current" : ""}`} />
            {u.reaction_count > 0 ? u.reaction_count : "Acknowledge"}
          </button>
        </div>
      ))}
    </div>
  );
}
